module.exports = __webpack_public_path__ + "static/banner_ast_soc-56f79821316cfd1caca54b1c6578bd67.png";